import QRCode from "qrcode";

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new window.Image();
    img.crossOrigin = "anonymous";
    img.decoding = "async";
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = String(src || "").trim();
  });
}

async function loadSvgDataUrl(src) {
  const response = await fetch(String(src || "").trim(), { cache: "force-cache" });
  if (!response.ok) {
    throw new Error(`Unable to load SVG icon: ${response.status}`);
  }

  const raw = (await response.text()).trim();
  if (!raw) {
    throw new Error("SVG icon content is empty.");
  }

  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(raw)}`;
}

export async function makeBrandedQrDataUrl(
  text,
  {
    iconSrc = "",
    size = 768,
    margin = 2,
    badgeScale = 0.18,
    iconScale = 0.56,
  } = {},
) {
  const value = String(text || "").trim();
  if (!value || typeof document === "undefined") return "";

  const canvas = document.createElement("canvas");
  await QRCode.toCanvas(canvas, value, {
    width: size,
    margin,
    errorCorrectionLevel: "H",
    color: {
      dark: "#000000",
      light: "#ffffff",
    },
  });

  const safeIconSrc = String(iconSrc || "").trim();
  if (!safeIconSrc) return canvas.toDataURL("image/png");

  try {
    const iconSource =
      /\.svg(?:[?#].*)?$/i.test(safeIconSrc) ? await loadSvgDataUrl(safeIconSrc) : safeIconSrc;
    const icon = await loadImage(iconSource);
    const ctx = canvas.getContext("2d");
    if (!ctx) return canvas.toDataURL("image/png");

    const badgeSize = Math.round(size * badgeScale);
    const iconSize = Math.round(badgeSize * iconScale);
    const centerX = Math.round(size / 2);
    const centerY = Math.round(size / 2);
    const iconWidth = Number(icon.naturalWidth || icon.width || 0);
    const iconHeight = Number(icon.naturalHeight || icon.height || 0);
    const safeWidth = iconWidth > 0 ? iconWidth : iconSize;
    const safeHeight = iconHeight > 0 ? iconHeight : iconSize;
    const fitScale = Math.min(iconSize / safeWidth, iconSize / safeHeight);
    const drawWidth = Math.round(safeWidth * fitScale);
    const drawHeight = Math.round(safeHeight * fitScale);

    ctx.save();
    ctx.beginPath();
    ctx.arc(centerX, centerY, badgeSize / 2, 0, Math.PI * 2);
    ctx.fillStyle = "#ffffff";
    ctx.fill();
    ctx.clip();
    ctx.closePath();
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";
    ctx.filter = "grayscale(1)";

    ctx.drawImage(
      icon,
      centerX - drawWidth / 2,
      centerY - drawHeight / 2,
      drawWidth,
      drawHeight,
    );
    ctx.filter = "none";
    ctx.restore();
  } catch {
    // Fall back to the plain QR if the icon cannot be painted.
  }

  return canvas.toDataURL("image/png");
}
